// imports shared across all careers portal templates
require('../careers-portal/base/imports');

// modules
require('../site_scripts/mtc_youtube_overlay');
require('../careers-portal/modules/table');
require('../careers-portal/modules/benefit-toggle');
require('../careers-portal/modules/types-slider');

// careers portal page styles
require('../../styles/entry/careers-portal.less')
